/**
 * Created by why on 2019/8/17.
 */
import axios from '@/libs/api.request'
export const roleList = ({pageNum, pageSize, sort, order}) => {
  return axios.request({
    url: '/role/selectAll',
    params: {
      pageNum,
      pageSize,
      sort,
      order
    },
    method: 'get'
  })
}

export const roleAllList = () => {
  return axios.request({
    url: '/role/all',
    method: 'get'
  })
}

export const roleInsert = (data) => {
  return axios.request({
    url: '/role/insert',
    data: data,
    method: 'post'
  })
}

export const roleDelete = (data) => {
  return axios.request({
    url: '/role/delete',
    data: data,
    method: 'post'
  })
}

export const roleUpdate = (data) => {
  return axios.request({
    url: '/role/update',
    data: data,
    method: 'post'
  })
}

export const findByIdRole = (id) => {
  return axios.request({
    url: '/role/findById',
    params: id,
    method: 'get'
  })
}

export const getMenuTree = (status) => {
  return axios.request({
    url: '/menu/getAllList',
    method: 'get',
    params: status
  })
}

export const editMenu = ({roleId, list}) => {
  return axios.request({
    url: '/role/editMenu',
    data: {roleId, list},
    method: 'POST'
  })
}



// WEBPACK FOOTER //
// ./src/api/role-manage.js